import PropTypes from 'prop-types';
import Immutable from 'seamless-immutable';

import { actions } from './actions';

import { country } from '../../utils/propTypes';

/* ------------- Auth reducer ------------- */
const defaultState = {
  loaded: false,
  loading: false,
  list: null,
};

/* eslint-disable complexity */
export function reducer(state = Immutable(defaultState), action) {
  switch (action.type) {
    case actions.LOAD_START: {
      return state.merge({ loaded: false, loading: true, list: null });
    }
    case actions.LOAD_SUCCESS: {
      return state.merge({ loaded: true, loading: false, list: action.payload.list });
    }
    case action.LOAD_FAIL: {
      return state.merge({ loaded: true, loading: false, list: [] });
    }
    default: {
      return state;
    }
  }
}
/* eslint-enable complexity */

/* ------------- Auth propTypes ------------- */
export const propTypes = {
  loaded: PropTypes.bool.isRequired,
  list: PropTypes.arrayOf(country),
};



// WEBPACK FOOTER //
// ./src/redux/Countries/reducer.js